import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Otherheader from "../Header/Otherheader";
import { Container, Row, Col } from "react-bootstrap";
import { LiaGreaterThanSolid } from "react-icons/lia";
import service22 from "../../assets/service22.webp";
import service23 from "../../assets/service23.webp";
import service24 from "../../assets/service24.webp";
import service25 from "../../assets/service25.webp";
import service26 from "../../assets/service26.webp";
import service27 from "../../assets/service27.webp";
import service28 from "../../assets/service28.webp";
import service29 from "../../assets/service29.webp";
import service30 from "../../assets/service30.webp";
import service31 from "../../assets/service31.webp";
import service32 from "../../assets/service32.webp";
import service33 from "../../assets/service33.webp";
import service34 from "../../assets/service34.webp";
import service35 from "../../assets/service35.webp";
import service36 from "../../assets/service36.webp";
import service37 from "../../assets/service37.webp";
import service38 from "../../assets/service38.webp";
import "./Services.css";
import Whatsapp from "../Whatsapp/Whatsapp";
import { Helmet } from "react-helmet-async";

const Gservices = () => {
  const { section } = useParams();

  useEffect(() => {
    const targetSection = document.getElementById(section);
    if (targetSection) {
      targetSection.scrollIntoView({ behavior: "smooth" });
    }
  }, [section]);

  return (
    <>
      <Otherheader />
      <Helmet>
        <title>Dr. Gaurav Pandey – Expert Pulmonologist & Diabetologist</title>
        <meta
          name="keywords"
          content="pneumonia treatment in delhi, chest specialist in pitampura, allergy specialist in delhi, allergy expert near me,chest specialist in rohini, best chest specialist in delhi, best allergy expert near me,skin allergy doctor near me,skin allergy specialist doctor near me,allergy specialist doctor in delhi,Best Skin Allergy Treatment Doctors Near Pitampura, Delhi"
        />
        <meta
          name="description"
          content="Dr. Gaurav Pandey is a reliable Chest & Allergy Expert, Pulmonologist, and Diabetologist, providing specialist treatment for respiratory issues, allergies, asthma, COPD, diabetes, and high blood pressure. Utilizing cutting-edge therapies in pulmonary medicine and chronic disease management, he offers tailored approaches for improved lung health and overall wellness. Schedule a consultation today"
        />
      </Helmet>
      <div className="service_banner">
        <Container>
          <div className="appoint_left">
            <p className="lets">
              Home <LiaGreaterThanSolid className="lets_icon" /> Services{" "}
            </p>
          </div>

          <div className="gallery_head text-white">
            <h2 className="pt-5">
              Services at Sharva <br /> clinic{" "}
            </h2>
            <p className="pt-2">
              Explore our range of expert services, each tailored to your <br />{" "}
              unique needs and delivered by our skilled team of professionals{" "}
              <br /> at Sharva Clinic. Your journey towards enhanced health and
              beauty starts here.
            </p>
          </div>
        </Container>
      </div>

      <div className="service_content my-5">
        <div className="service_head text-center mb-5">
          <h2>
            Our <span>Services</span>
          </h2>
        </div>

        <Container>
          <Row className="pt-5">
            <Col md={6}>
              <div className="service_img mt-3">
                <img src={service22} alt="top asthma clinic in Delhi" />
              </div>
            </Col>
            <Col md={6}>
              <div className="service_name" id="asthma">
                <div className="service_desc">
                  <h5 className="py-3">Asthma </h5>
                  <p>
                    Experience comprehensive asthma care at the{" "}
                    <strong>top asthma clinic in Delhi </strong> under the
                    guidance of our expert Pulmonologist. With precision and
                    empathy, we provide tailored treatments to manage and
                    alleviate asthma symptoms. Our Pulmonologist's advanced
                    knowledge ensures accurate diagnosis, personalized
                    medication plans, and lifestyle guidance to enhance your
                    quality of life. Trust in the hands of our experienced
                    specialist to help you breathe freely and confidently.
                    Through expert care and cutting-edge therapies, we are
                    dedicated to empowering you in your journey toward effective
                    asthma management and improved respiratory health. Breathe
                    easier and embrace life fully with our specialized treatment
                    of asthma.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="pt-5">
            <Col md={6}>
              <div className="service_name" id="copd">
                <div className="service_desc">
                  <h5 className="py-3">
                    COPD (Chronic Obstructive Pulmonary Disease){" "}
                  </h5>
                  <p>
                    Receive specialized care for Chronic Obstructive Pulmonary
                    Disease (COPD) from our dedicated Pulmonologist. With
                    expertise and compassion, we offer comprehensive treatments
                    to manage COPD symptoms and enhance your respiratory
                    well-being. Our Pulmonologist's precise diagnosis and
                    personalized treatment plans ensure optimal management of
                    this chronic condition. Through advanced therapies,
                    lifestyle guidance, and continuous monitoring, we strive to
                    improve your lung function and overall quality of life.
                    Trust in the expertise of our experienced specialist to
                    guide you towards better respiratory health and a more
                    active, fulfilling lifestyle. Regain control over your
                    breathing and embrace a life enriched by our expert COPD
                    treatment.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="service_img mt-3">
                <img src={service23} alt="COPD Treatment in Delhi" />
              </div>
            </Col>
          </Row>
          <Row className="pt-5"  style={{display:"flex", margin:"auto",alignItems:"center"}}>
            <Col md={6}>
              <div className="service_img mt-3">
                <img src={service24} alt="best allergy specialist in Delhi" />
              </div>
            </Col>
            <Col md={6}>
              <div className="service_name" id="allergies">
                <div className="service_desc">
                  <h5 className="py-3">Allergies </h5>
                  <p>
                    At Sharva Clinic, we understand how disruptive allergies can
                    be to your daily life. Whether it’s persistent coughing,
                    sneezing, skin rashes, or unexplained breathing
                    difficulties, identifying the root cause is the first step
                    toward effective relief. <strong>Under the expert care of allergy
                    specialist Dr. Gaurav Pandey at sharva clinic</strong>, our
                    comprehensive testing services help pinpoint specific
                    allergens—be it dust, pollen, pet dander, mold, or certain
                    foods—so we can create a personalized treatment plan. One of
                    our key diagnostic tools is the Skin Prick Allergy Test
                    (SPT), a simple and safe procedure that involves applying
                    tiny amounts of potential allergens to the skin and
                    observing the body’s response. Within 30 minutes, we can
                    identify sensitivities to common environmental or food
                    allergens. For those with chronic or severe allergies, we
                    offer Allergen Immunotherapy—a long-term treatment that
                    gradually builds your body’s tolerance to specific
                    allergens. It is available as allergy shots (SCIT) or
                    sublingual tablets/drops (SLIT) taken at home. At Sharva
                    Clinic, we are committed to providing safe, personalized,
                    and evidence-based allergy care. Book your consultation
                    today and take the first step toward lasting relief and
                    better breathing.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="pt-5">
            <Col md={6}>
              <div className="service_name" id="tb">
                <div className="service_desc">
                  <h5 className="py-3">Tuberculosis (TB)</h5>
                  <p>
                    Receive comprehensive care for Tuberculosis (TB) from our
                    experienced medical team. Our dedicated experts ensure
                    accurate diagnosis, personalized treatment plans, and
                    ongoing monitoring to effectively manage TB. With a focus on
                    antibiotic therapy and patient support, we guide you through
                    the entire treatment process, ensuring adherence and
                    minimizing potential side effects. Trust in our expertise to
                    help you overcome TB and regain your health. Through
                    advanced therapies and compassionate care, we are committed
                    to your well-being and the eradication of this infectious
                    disease. Embrace a journey towards recovery and a brighter,
                    healthier future with our expert TB treatment.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="service_img mt-3">
                <img src={service25} alt="tb treatment in delhi" />
              </div>
            </Col>
          </Row>
          <Row className="pt-5">
            <Col md={6}>
              <div className="service_img mt-3">
                <img src={service26} alt="cough and cold treatment in delhi" />
              </div>
            </Col>
            <Col md={6}>
              <div className="service_name" id="cough">
                <div className="service_desc">
                  <h5 className="py-3">Cough and Cold Treatment</h5>
                  <p>
                    Receive quick and efficient alleviation from cough and cold
                    symptoms through the professional assistance of our skilled
                    medical team. Whether it’s a persistent cough, nasal
                    congestion, or overall unease, we offer tailored care to
                    assist you in recuperating swiftly and comfortably. We
                    customize our method to suit your requirements, providing a
                    range of options from OTC treatments to prescription drugs.
                    Our experts also offer useful self-care tips to enhance your
                    immunity and accelerate recovery. Prioritizing your health,
                    we guarantee that you receive the appropriate medical
                    assistance at every stage. If you need{" "}
                    <strong>
                      best cough and cold treatment near pitampura, delhi
                    </strong>{" "}
                    rely on our staff to assist you in breathing better and
                    feeling improved quickly.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="pt-5">
            <Col md={6}>
              <div className="service_name" id="chest">
                <div className="service_desc">
                  <h5 className="py-3">Chest Infection</h5>
                  <p>
                    Get expert care for chest infections with our trusted
                    medical team in Delhi. Whether you're dealing with
                    bronchitis, pneumonia, or other respiratory conditions, we
                    provide accurate diagnosis and effective treatment to help
                    you recover quickly. Using advanced diagnostic techniques,
                    our specialists identify the root cause of your infection
                    and create a personalized treatment plan just for you. From
                    targeted medications and respiratory therapies to symptom
                    management, we focus on your comfort and well-being every
                    step of the way. With continuous monitoring and timely
                    adjustments, we ensure the best possible recovery. Rely on
                    the{" "}
                    <strong>
                      {" "}
                      best chest specialist near Pitampura, Delhi NCR
                    </strong>{" "}
                    for expert guidance and compassionate care. Breathe easier,
                    heal faster, and take a step toward better respiratory
                    health with our specialized treatment.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="service_img mt-3">
                <img src={service27} alt="chest infection treatment in Delhi" />
              </div>
            </Col>
          </Row>
          <Row className="pt-5">
            <Col md={6}>
              <div className="service_img mt-3">
                <img src={service28} alt="snoring treatment in delhi" />
              </div>
            </Col>
            <Col md={6}>
              <div className="service_name" id="snoring">
                <div className="service_desc">
                  <h5 className="py-3">Snoring</h5>
                  <p>
                    Discover effective solutions for snoring through our
                    specialized care. Our experienced medical professionals
                    offer comprehensive assessment and tailored treatment plans
                    to address the underlying causes of snoring. From lifestyle
                    adjustments and positional therapy to oral appliances and,
                    if necessary, surgical options, we are committed to helping
                    you and your loved ones achieve restful sleep. Trust in our
                    expertise to guide you towards quieter nights and improved
                    sleep quality. With a focus on your well-being, we provide
                    personalized guidance and support to alleviate snoring and
                    its potential impact on your health. Embrace a more peaceful
                    sleep and a revitalized sense of energy with our expert
                    snoring treatment.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="pt-5">
            <Col md={6}>
              <div className="service_name" id="sleep">
                <div className="service_desc">
                  <h5 className="py-3">Sleep Disturbances</h5>
                  <p>
                    Receive prompt and effective care for chest infections from
                    our experienced medical team. We specialize in diagnosing
                    and treating a wide range of chest infections, including
                    bronchitis, pneumonia, and other respiratory conditions. Our
                    dedicated experts utilize advanced diagnostic techniques to
                    accurately identify the cause of your infection and develop
                    a personalized treatment plan. From antibiotics and
                    respiratory therapies to symptom management, we prioritize
                    your comfort and recovery. Trust in our expertise to guide
                    you through the healing process, ensuring thorough
                    monitoring and timely adjustments to your treatment. Embrace
                    a healthier respiratory future with our specialized chest
                    infection treatment, tailored to your individual needs.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="service_img mt-3">
                <img src={service29} alt="" />
              </div>
            </Col>
          </Row>
          <Row className="pt-5">
            <Col md={6}>
              <div className="service_img mt-3">
                <img
                  src={service30}
                  alt="respiratory issues treatment in delhi"
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="service_name" id="respiratory">
                <div className="service_desc">
                  <h5 className="py-3">Respiratory Issues</h5>
                  <p>
                    Experience comprehensive care for respiratory issues from
                    our specialized medical team. We are dedicated to diagnosing
                    and managing a wide range of respiratory conditions,
                    including asthma, chronic obstructive pulmonary disease
                    (COPD), pneumonia, bronchitis, and more. Our experts utilize
                    advanced diagnostic tools to accurately assess your lung
                    health and develop personalized treatment plans. From
                    inhalers and medications to pulmonary rehabilitation and
                    lifestyle adjustments, we prioritize your respiratory
                    well-being. Trust in our expertise to guide you towards
                    improved lung function and a higher quality of life. With a
                    focus on your health and comfort, we provide ongoing support
                    and monitoring to help you breathe easier and enjoy better
                    respiratory health. Embrace the potential for enhanced lung
                    function and vitality with our expert treatment of
                    respiratory issues.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="pt-5">
            <Col md={6}>
              <div className="service_name" id="sinusitis">
                <div className="service_desc">
                  <h5 className="py-3">Sinusitis</h5>
                  <p>
                    Experience effective relief from sinusitis with our
                    specialized care. Our experienced medical team is dedicated
                    to diagnosing and treating sinus infections and
                    inflammation. We offer personalized treatment plans that may
                    include antibiotics, decongestants, nasal sprays, and pain
                    relievers to alleviate symptoms and promote healing. Trust
                    in our expertise to guide you through the recovery process,
                    providing thorough monitoring and adjustments as needed.
                    With a focus on your comfort and well-being, we strive to
                    help you breathe easier and enjoy a healthier quality of
                    life. Embrace the potential for sinus relief and improved
                    sinus health with our expert sinusitis treatment.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="service_img mt-3">
                <img src={service31} alt="Sinusitis treatment in delhi" />
              </div>
            </Col>
          </Row>
          <Row className="pt-5">
            <Col md={6}>
              <div className="service_img mt-3">
                <img src={service32} alt="eosinophilia treatment in delhi" />
              </div>
            </Col>
            <Col md={6}>
              <div className="service_name" id="eosinophilia">
                <div className="service_desc">
                  <h5 className="py-3">Eosinophilia </h5>
                  <p>
                    Receive specialized care for eosinophilia from our dedicated
                    medical team. Eosinophilia is a condition characterized by
                    elevated levels of eosinophils, a type of white blood cell,
                    which can be caused by various underlying factors such as
                    allergies, infections, autoimmune disorders, or other
                    medical conditions. Our experts are skilled in diagnosing
                    the cause of eosinophilia and developing tailored treatment
                    plans to address the root cause and manage symptoms. Trust
                    in our expertise to guide you towards effective management
                    of eosinophilia, providing thorough monitoring and necessary
                    interventions. With a focus on your health and well-being,
                    we strive to help you achieve optimal blood cell balance and
                    overall vitality. Embrace the potential for improved health
                    and well-being with our expert eosinophilia care.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="pt-5">
            <Col md={6}>
              <div className="service_name" id="diabetes">
                <div className="service_desc">
                  <h5 className="py-3">Diabetes</h5>
                  <p>
                    Experience comprehensive care for diabetes from our
                    specialized medical team. We are dedicated to managing all
                    aspects of diabetes, including type 1, type 2, and
                    gestational diabetes. Our experts offer personalized
                    treatment plans that may include blood sugar monitoring,
                    oral medications, insulin therapy, lifestyle modifications,
                    and nutritional guidance. Trust in our expertise to guide
                    you towards better blood sugar control and improved overall
                    health. With a focus on your well-being, we provide ongoing
                    support, education, and monitoring to help you effectively
                    manage diabetes and reduce the risk of complications.
                    Embrace the potential for better glucose control and
                    enhanced quality of life with our expert diabetes treatment.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="service_img mt-3">
                <img src={service33} alt="expert diabetes treatment in delhi" />
              </div>
            </Col>
          </Row>
          <Row className="pt-5">
            <Col md={6}>
              <div className="service_img mt-3">
                <img
                  src={service34}
                  alt="diabetic neuropathy treatment in delhi"
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="service_name" id="neuropathy">
                <div className="service_desc">
                  <h5 className="py-3">Diabetic Neuropathy</h5>
                  <p>
                    Receive specialized care for diabetic neuropathy from our
                    dedicated medical team. Diabetic neuropathy is a condition
                    that affects the nerves, often causing numbness, tingling,
                    pain, or weakness in the extremities. Our experts are
                    skilled in diagnosing and managing diabetic neuropathy,
                    offering tailored treatment plans to alleviate symptoms and
                    prevent progression. Trust in our expertise to guide you
                    toward effective management, which may include medications
                    to control pain and discomfort, lifestyle adjustments, and
                    methods to improve blood sugar control. With a focus on your
                    well-being, we provide ongoing support and monitoring to
                    help you achieve relief and maintain optimal nerve health.
                    Embrace the potential for improved nerve function and
                    enhanced quality of life with our expert diabetic neuropathy
                    care.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="pt-5">
            <Col md={6}>
              <div className="service_name" id="hypertension">
                <div className="service_desc">
                  <h5 className="py-3">Hypertension </h5>
                  <p>
                    Receive specialized care for hypertension (high blood
                    pressure) from our dedicated medical team. Hypertension is a
                    common condition that can increase the risk of heart
                    disease, stroke, and other health complications. Our experts
                    are skilled in diagnosing and managing hypertension,
                    offering personalized treatment plans that may include
                    lifestyle modifications, dietary changes, exercise
                    recommendations, and medications when necessary. Trust in
                    our expertise to guide you towards better blood pressure
                    control and improved cardiovascular health. With a focus on
                    your well-being, we provide ongoing support, education, and
                    monitoring to help you effectively manage hypertension and
                    reduce associated risks. Embrace the potential for lower
                    blood pressure and enhanced overall health with our expert
                    hypertension care.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="service_img mt-3">
                <img src={service35} alt="hypertension treatment in delhi" />
              </div>
            </Col>
          </Row>
          <Row className="pt-5">
            <Col md={6}>
              <div className="service_img mt-3">
                <img
                  src={service36}
                  alt="electrocardiogram treatment in delhi"
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="service_name" id="ecg">
                <div className="service_desc">
                  <h5 className="py-3">ECG (Electrocardiogram) </h5>
                  <p>
                    Experience advanced heart health assessment with our
                    Electrocardiogram (ECG) service. Using state-of-the-art
                    technology, we record your heart's electrical activity to
                    detect irregularities, such as arrhythmias or heart
                    conditions. Our skilled medical team ensures accurate
                    results, aiding in early diagnosis and effective management
                    of cardiac health. Trust in our expertise to provide a
                    comprehensive ECG analysis, contributing to your overall
                    well-being and heart health. Embrace the potential for early
                    detection and timely intervention with our expert ECG
                    service.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="pt-5">
            <Col md={6}>
              <div className="service_name" id="pft">
                <div className="service_desc">
                  <h5 className="py-3">PFT (Pulmonary Function Test)</h5>
                  <p>
                    Elevate your respiratory health with our Pulmonary Function
                    Test (PFT) service. Using advanced equipment, we measure
                    your lung capacity, airflow, and overall lung function. Our
                    dedicated medical team ensures precise assessments, helping
                    diagnose conditions like asthma, COPD, and lung diseases.
                    Trust in our expertise to provide comprehensive PFT
                    analysis, contributing to better respiratory well-being and
                    lung health. Embrace the potential for early detection and
                    personalized treatment with our expert PFT service.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="service_img mt-3">
                <img src={service37} alt="Pulmonary Function Test in delhi" />
              </div>
            </Col>
          </Row>
          <Row className="pt-5">
            <Col md={6}>
              <div className="service_img mt-3">
                <img src={service38} alt="sugar profile test in delhi" />
              </div>
            </Col>
            <Col md={6}>
              <div className="service_name" id="sugar">
                <div className="service_desc">
                  <h5 className="py-3">Sugar Profile</h5>
                  <p>
                    Prioritize your metabolic health with our Sugar Profile
                    service. This comprehensive assessment measures blood
                    glucose levels, aiding in the early detection and management
                    of diabetes. Our experienced medical team ensures accurate
                    readings, enabling timely interventions and lifestyle
                    modifications. Trust in our expertise to provide thorough
                    sugar profile analysis, contributing to improved blood sugar
                    control and overall well-being. Embrace the potential for
                    early intervention and informed choices for a healthier
                    future with our expert Sugar Profile service.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Whatsapp />
    </>
  );
};

export default Gservices;
